import { useParams, Link } from 'react-router-dom'

/**
 * UGC 谜题游玩页面
 * TODO: 实现从 Supabase 加载用户谜题
 */
export function PlayPage() {
  const { id } = useParams<{ id: string }>()

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="text-center max-w-md">
        <h1 className="text-3xl font-bold text-white mb-4">
          🎮 用户谜题
        </h1>
        <p className="text-gray-400 mb-2">
          谜题 ID: <span className="font-mono text-indigo-400">{id}</span>
        </p>
        
        <div className="bg-yellow-900/30 border border-yellow-600/30 rounded-xl p-6 my-8">
          <h2 className="text-yellow-400 font-semibold mb-2">🚧 功能开发中</h2>
          <p className="text-yellow-200/70">
            用户生成内容功能正在开发中，敬请期待...
          </p>
        </div>
        
        <Link to="/daily" className="btn btn-primary">
          先去玩今日谜题
        </Link>
      </div>
    </div>
  )
}

